function copyScript() {
    const copyButtons = document.querySelectorAll(".copy");
    if (copyButtons.length <= 0) return;

    copyButtons.forEach(function (button) {
        button.addEventListener("click", function (e) {
            e.preventDefault();

            const container = button.closest(".code-container");
            const codeEl = container.querySelector("code");

            const tempEl = document.createElement("textarea");
            tempEl.innerHTML = codeEl.innerHTML;
            const plainText = tempEl.value.trim();

            navigator.clipboard
                .writeText(plainText)
                .then(function () {
                    const originalText = button.textContent;
                    button.textContent = "Copied!";
                    button.classList.add("copied");

                    setTimeout(function () {
                        button.textContent = originalText;
                        button.classList.remove("copied");
                    }, 2000);
                })
                .catch(function () {
                    const range = document.createRange();
                    range.selectNode(codeEl);
                    window.getSelection().removeAllRanges();
                    window.getSelection().addRange(range);
                    document.execCommand("copy");
                    window.getSelection().removeAllRanges();

                    button.textContent = "Copied!";
                    setTimeout(function () {
                        button.textContent = "Copy code";
                    }, 2000);
                });
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    copyScript();
});
